export const cuesReducer = (state, action) => {
  switch (action.type) {
    case "FETCH":
      return { cueStore: action.payload };

    default:
      return state;
  }
};
